import React from 'react'
import PropTypes from 'prop-types'
import { Breadcrumb, Breadcrumbs, Typography } from '@chilecompra/react-kit/components'
import { Root } from './QuoteCreationHeading.styles'

const QuoteCreationHeading = props => {
  const { breadcrumbs, description, disclaimers, step, title } = props

  return (
    <Root>
      <Breadcrumbs>
        {breadcrumbs.map((breadcrumb, key) => (
          <Breadcrumb key={key} onClick={breadcrumb?.onRedirectTo}>
            {breadcrumb?.text}
          </Breadcrumb>
        ))}
      </Breadcrumbs>
      {disclaimers?.map((NotificationComponent, index) => (
        <React.Fragment key={index}>{NotificationComponent}</React.Fragment>
      ))}
      <Typography color="black3" fontWeight="bold" margin="28px 0 0" variant="caption">
        {step}
      </Typography>
      <Typography color="black1" fontWeight="bold" margin="4px 0 0" variant="h2">
        {title}
      </Typography>
      <Typography color="black1" margin="5px 0 16px 0" variant="body2">
        {description}
      </Typography>
    </Root>
  )
}

QuoteCreationHeading.defaultProp = {
  breadcrumbs: [],
  description: '',
  disclaimers: [],
  step: '',
  title: ''
}

QuoteCreationHeading.propTypes = {
  breadcrumbs: PropTypes.array,
  description: PropTypes.string,
  disclaimers: PropTypes.array,
  step: PropTypes.string,
  title: PropTypes.string
}

export default QuoteCreationHeading
